import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { changeLastProduct } from '../brand/ducks/index.js';
import { getProductFromPath } from './sportsbook-get-product-from-path';
import { PRODUCT_TO_LAST_PRODUCT } from './sportsbook-constants.js';

const useUpdateSportsbookLastProduct = () => {
	const location = useLocation();
	const dispatch = useDispatch();

	useEffect(() => {
		const product = getProductFromPath(location.pathname);
		dispatch(changeLastProduct(PRODUCT_TO_LAST_PRODUCT[product]));
	}, [dispatch, location.pathname]);
};

export default useUpdateSportsbookLastProduct;
